"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TypeOff_exports = {};
__export(TypeOff_exports, {
  default: () => TypeOff_default
});
module.exports = __toCommonJS(TypeOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.875 0.25C20.0443 0.25 20.1875 0.315104 20.3047 0.445312C20.4349 0.5625 20.5 0.705729 20.5 0.875V19.625C20.5 19.7943 20.4349 19.9375 20.3047 20.0547C20.1875 20.1849 20.0443 20.25 19.875 20.25H1.125C0.955729 20.25 0.80599 20.1849 0.675781 20.0547C0.558594 19.9375 0.5 19.7943 0.5 19.625V0.875C0.5 0.705729 0.558594 0.5625 0.675781 0.445312C0.80599 0.315104 0.955729 0.25 1.125 0.25H19.875ZM18.625 1.5H2.375C2.21875 1.5 2.08203 1.55208 1.96484 1.65625C1.86068 1.7474 1.79557 1.86458 1.76953 2.00781L1.75 2.125V18.375C1.75 18.5312 1.79557 18.668 1.88672 18.7852C1.99089 18.8893 2.11458 18.9544 2.25781 18.9805L2.375 19H18.625C18.7812 19 18.9115 18.9544 19.0156 18.8633C19.1328 18.7591 19.2044 18.6354 19.2305 18.4922L19.25 18.375V2.125C19.25 1.95573 19.1849 1.8125 19.0547 1.69531C18.9375 1.5651 18.7943 1.5 18.625 1.5ZM11.418 3.19922C11.5482 3.19922 11.6654 3.23828 11.7695 3.31641C11.8737 3.38151 11.9518 3.47917 12.0039 3.60938L16.7891 15.6406C16.8021 15.6797 16.8086 15.7188 16.8086 15.7578C16.8216 15.7969 16.8281 15.8359 16.8281 15.875C16.8281 16.0443 16.7695 16.194 16.6523 16.3242C16.5352 16.4414 16.3854 16.5 16.2031 16.5H15.5781C15.4479 16.5 15.3242 16.4674 15.207 16.4023C15.1029 16.3242 15.0312 16.2266 14.9922 16.1094L13.8594 13.1797C13.8073 13.0625 13.7292 12.9714 13.625 12.9062C13.5208 12.8281 13.4036 12.7891 13.2734 12.7891H8.23438C8.11719 12.7891 8 12.8281 7.88281 12.9062C7.77865 12.9714 7.70703 13.069 7.66797 13.1992L6.55469 16.0898C6.51562 16.2201 6.4375 16.3242 6.32031 16.4023C6.21615 16.4674 6.09896 16.5 5.96875 16.5H5.36328C5.32422 16.5 5.28516 16.5 5.24609 16.5C5.20703 16.487 5.16797 16.474 5.12891 16.4609C4.97266 16.3958 4.85547 16.2852 4.77734 16.1289C4.71224 15.9596 4.71224 15.7969 4.77734 15.6406L9.5625 3.60938C9.61458 3.47917 9.69271 3.38151 9.79688 3.31641C9.90104 3.23828 10.0182 3.19922 10.1484 3.19922H11.418ZM10.9688 6.28516C10.7995 6.22005 10.6367 6.22656 10.4805 6.30469C10.3242 6.36979 10.2135 6.48047 10.1484 6.63672L8.80078 10.2305C8.77474 10.2695 8.75521 10.3086 8.74219 10.3477C8.74219 10.3867 8.74219 10.4258 8.74219 10.4648C8.74219 10.6341 8.80078 10.7839 8.91797 10.9141C9.04818 11.0312 9.19792 11.0898 9.36719 11.0898H12.1406C12.1797 11.0898 12.2122 11.0833 12.2383 11.0703C12.2773 11.0573 12.3164 11.0443 12.3555 11.0312C12.5117 10.9792 12.6224 10.875 12.6875 10.7188C12.7656 10.5495 12.7721 10.3867 12.707 10.2305L11.3203 6.63672C11.2943 6.55859 11.2487 6.48698 11.1836 6.42188C11.1185 6.35677 11.0469 6.3112 10.9688 6.28516Z",
      fill: "currentColor"
    }
  )
);
const SvgTypeOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var TypeOff_default = SvgTypeOff;
